module.exports = __webpack_public_path__ + "ipetbooking/admin/img/online-credit-card.7830c3d6.svg";